import React from "react";


const ContactMe = () => {
  return (
    <div>
      <h2>Flip93Wolf@gmail.com</h2>
      <p>
        <a href="mailto:Flip93wolf@gmail.com">
          Please click here to open up your Email App and Message Kyle!
        </a>
      </p>
    </div>
  );
};
export default ContactMe;

